import { useWsmKitConfigCreateMutation } from "@dashboard/graphql";
import useNavigator from "@dashboard/hooks/useNavigator";
import useNotifier from "@dashboard/hooks/useNotifier";
import { commonMessages } from "@dashboard/intl";
import { getMutationState } from "@dashboard/misc";
import React, { useState } from "react";
import { useIntl } from "react-intl";

import WsmCollectionField from "../components/WsmCollectionField/WsmCollectionField";
import WsmKitDetailsPage from "../components/WsmKitDetailsPage/WsmKitDetailsPage";
import { getWsmKitsErrorMessage } from "../errors";
import { sectionMessages } from "../messages";
import { wsmKitUrl } from "../urls";
import { emptyKitFormData, getKitCreateInput } from "../utils";

export const WsmKitCreateView = () => {
  const intl = useIntl();
  const navigate = useNavigator();
  const notify = useNotifier();
  const [collection, setCollection] = useState("");
  const [createKit, createKitOpts] = useWsmKitConfigCreateMutation({
    onCompleted: result => {
      const kit = result.wsmKitConfigCreate?.kit;

      if (kit && !result.wsmKitConfigCreate?.errors.length) {
        notify({ status: "success", text: intl.formatMessage(commonMessages.savedChanges) });
        navigate(wsmKitUrl(kit.id));
      }
    },
  });
  const errors = createKitOpts.data?.wsmKitConfigCreate?.errors ?? [];
  const collectionError = errors.find(error => error.field === "collection");

  return (
    <WsmKitDetailsPage
      title={intl.formatMessage(sectionMessages.createKitTitle)}
      initialData={emptyKitFormData()}
      errors={errors}
      disabled={createKitOpts.loading}
      saveButtonBarState={getMutationState(createKitOpts.called, createKitOpts.loading, errors)}
      collectionField={
        <WsmCollectionField
          value={collection}
          disabled={createKitOpts.loading}
          error={getWsmKitsErrorMessage(collectionError, intl)}
          onChange={setCollection}
        />
      }
      onSubmit={formData =>
        createKit({ variables: { input: getKitCreateInput({ ...formData, collection }) } })
      }
    />
  );
};

export default WsmKitCreateView;
